import { NetworkSubmissionWizardStep } from "@app/compliance-connect/network-submission/interfaces";
import { NetworkSubmissionWizardAction, NetworkSubmissionWizardActions } from "@app/compliance-connect/network-submission/networkSubmissionWizardActions";
import { NetworkSubmissionWizardState } from "@app/compliance-connect/network-submission/networkSubmissionWizardState";

const isStepValid = (state: NetworkSubmissionWizardState): boolean => {
  switch (state.page) {
    case NetworkSubmissionWizardStep.SelectRegulator:
      return state.regulatorClientId !== null;
    case NetworkSubmissionWizardStep.SelectProject:
      return state.selectedProject !== null;
    case NetworkSubmissionWizardStep.AdequacyReview:
    case NetworkSubmissionWizardStep.Exceptions:
      return true; // TODO: implement validation when steps are built
    case NetworkSubmissionWizardStep.Review:
      return (
        state.submissionName.trim() !== "" &&
        state.submissionDescription.trim() !== "" &&
        state.isConfirmed
      );
    default:
      return false;
  }
};

export const networkSubmissionWizardReducer = (
  state: NetworkSubmissionWizardState,
  action: NetworkSubmissionWizardActions
): NetworkSubmissionWizardState => {
  let next: NetworkSubmissionWizardState;
  switch (action.type) {
    case NetworkSubmissionWizardAction.AddPendingException: {
      const updated = new Map([
        ...state.pendingExceptions,
        [action.payload.key, action.payload.exception]
      ]);

      next = { ...state, pendingExceptions: updated };
      break;
    }
    case NetworkSubmissionWizardAction.SelectProject:
      next = { ...state, pendingExceptions: new Map(), selectedProject: action.payload };
      break;
    case NetworkSubmissionWizardAction.SetComments:
      next = { ...state, comments: action.payload };
      break;
    case NetworkSubmissionWizardAction.SetEmailSharedUsers:
      next = { ...state, emailSharedUsers: action.payload };
      break;
    case NetworkSubmissionWizardAction.SetIsConfirmed:
      next = { ...state, isConfirmed: action.payload };
      break;
    case NetworkSubmissionWizardAction.SetPage:
      next = { ...state, page: action.payload };
      break;
    case NetworkSubmissionWizardAction.SetRegulatorClientId:
      next = { ...state, regulatorClientId: action.payload };
      break;
    case NetworkSubmissionWizardAction.SetSharedUserIds:
      next = { ...state, sharedUserIds: action.payload };
      break;
    case NetworkSubmissionWizardAction.SetSubmissionDescription:
      next = { ...state, submissionDescription: action.payload };
      break;
    case NetworkSubmissionWizardAction.SetSubmissionName:
      next = { ...state, submissionName: action.payload };
      break;
    default:
      throw new Error(`Unhandled action: ${JSON.stringify(action)}`);
  }
  return Object.freeze({ ...next, isCurrentStepValid: isStepValid(next) });
};
